import styled from "styled-components";

export const Home = styled.div`
    text-align: center;
    margin: 100px auto;
    width: 100%;
    height: 1000px;
`;